import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { List } from 'immutable';
import { SearchableDropdown, LoadingPane, GenericError, InlineWarningList, Table, accessibilityNotificationsEmitter } from '../../common';
import { tenantHelpers } from '../../tenantInfo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as formProcessing from '@social-solutions/participant-portal-forms';
import * as modifyIntakeActions from './modify-intake-form.actions';
import * as intakeFormConstants from './intake-form-constants';
import { IntakeFormValidation, validationConstants } from '../validate-intake-form';
import './modify-touchpoint.scss';
import EditQuestionModal from '../../intake/edit-question-modal';

export class ModifyTouchpointComponent extends Component {

  componentDidMount() {
    const { modifyIntakeActions, siteId, programId, selectedTouchpointId } = this.props;
    const { fetchTouchpointInfo, fetchTouchpoint, fetchValidTouchpoints, updatePreviewTabRedirect } = modifyIntakeActions;
    updatePreviewTabRedirect('/touchpoint');
    fetchTouchpointInfo();
    if(siteId && programId) {
      fetchValidTouchpoints(siteId, programId);
      if(selectedTouchpointId != null)
        fetchTouchpoint(siteId, programId, selectedTouchpointId);
    }
  }

  componentWillUpdate(nextProps) {
    const { modifyIntakeActions, siteId, programId, selectedTouchpointId } = this.props;
    const { siteId : nextSiteId, programId : nextProgramId, selectedTouchpointId : nextTouchpointId } = nextProps;
    const { fetchTouchpoint, fetchValidTouchpoints } = modifyIntakeActions;

    if(nextSiteId && nextProgramId) {
      if(nextSiteId !== siteId || nextProgramId !== programId)
        fetchValidTouchpoints(nextSiteId, nextProgramId);
      if(nextTouchpointId != null && nextTouchpointId !== selectedTouchpointId)
        fetchTouchpoint(nextSiteId, nextProgramId, nextTouchpointId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { modifyIntakeActions } = this.props;
    const { updatePreviewTabRedirect } = modifyIntakeActions || {};

    const { modifyIntake } = this.props;
    const { editQuestion } = modifyIntake;
    const { showQuestionEditModal } = editQuestion || {};

    const { modifyIntake: prevModifyIntake  } = prevProps;
    const { editQuestion: prevEditQuestion } = prevModifyIntake || {};
    const { showQuestionEditModal: prevShowQuestionEditModal } = prevEditQuestion;

    if(showQuestionEditModal && !prevShowQuestionEditModal) {
      var modalFocusTarget = document.getElementById('questionModalContent');
      if(modalFocusTarget) modalFocusTarget.focus();
    }
    else if(!showQuestionEditModal && prevShowQuestionEditModal) {
      var viewFocusTarget = document.getElementById('view');
      if(viewFocusTarget) viewFocusTarget.focus();
    }

    updatePreviewTabRedirect('/touchpoint');
  }

  handleUpdateTouchpoint(value) {
    const { updateTouchpoint } = this.props;
    updateTouchpoint(value);
  }

  handleKeyboardInput(e, elementId, label, moveUp) {
    if(e.keyCode === 13 || e.keyCode === 32) {
      this.handleUpdateOrder(elementId, label, moveUp);
    }
  }

  handleUpdateOrder(elementId, label, moveUp) {
    const { updateOrder } = this.props;
    updateOrder(intakeFormConstants.touchpointSection, intakeFormConstants.elementId, elementId, moveUp);

    const screenReaderText = moveUp ? label + " has moved up" : label + " has moved down";
    accessibilityNotificationsEmitter.assertive(screenReaderText);
  }

  /**
   * Checks form rules for the associated element. If that element is affected by any rules on the form,
   * automatically include in the form the elements that are assessed by those rules
   * @param {*} elementId id of the form element to check
   */
  handleRulesAdditions(elementId) {
    const { modifyIntake, selectedTouchpointId, value, updateValue } = this.props;
    const { touchpoints } = modifyIntake || {};
    const touchpointState = touchpoints && touchpoints.get(selectedTouchpointId);
    const { data : selectedTouchpoint } = touchpointState || {};

    const tpForm = selectedTouchpoint && formProcessing.convertRawForm(selectedTouchpoint);
    const elementsToInclude = tpForm && formProcessing.getAssessedElementsForTarget(tpForm, elementId);
    if (elementsToInclude && elementsToInclude.length > 0) {
      var questions = value && value.get(intakeFormConstants.touchpointSection);

      elementsToInclude.forEach(el => {
        // check if this element has not yet been included
        const question = questions.find(val => val.get(intakeFormConstants.elementId) === el);
        const existingIndex = questions.findIndex(val => val.get(intakeFormConstants.elementId) === el);
        const index = existingIndex === -1 ? questions.size : existingIndex;
        if ( (question && question.get(intakeFormConstants.included) === false) || existingIndex === -1 ) {
          updateValue([intakeFormConstants.touchpointSection, index, intakeFormConstants.included], true);
          this.handleRulesAdditions(el);
        }
      });
    }
  }


  handleUpdateIncluded(elementId, sectionValue) {
    this.handleUpdateQuestion(elementId, intakeFormConstants.included, sectionValue);
    if(!sectionValue) {
      this.handleUpdateQuestion(elementId, intakeFormConstants.required, sectionValue);
    }
  }

  handleUpdateQuestion(elementId, section, sectionValue) {
    const { updateValue, value } = this.props;
    var questions = value && value.get(intakeFormConstants.touchpointSection);
    var index = 0;
    if(!!questions) {
      var existingIndex = questions.findIndex(val => val.get(intakeFormConstants.elementId) === elementId);
      if(existingIndex === -1) {
        index = questions.size;
      }
      else {
        index = existingIndex;
      }
    }

    updateValue([intakeFormConstants.touchpointSection, index, section], sectionValue, true);

    // rules check - may need to include other elements if this is affected by one or more form rules
    if(section === intakeFormConstants.included && sectionValue)
      this.handleRulesAdditions(elementId);
  }

  handleEditQuestionCancel() {
    const { modifyIntakeActions } = this.props;
    const { closeTouchpointQuestionEditModal } = modifyIntakeActions || {};
    closeTouchpointQuestionEditModal();
  }

  handleEditClick(touchpointId) {
    const { modifyIntakeActions, match, formMode } = this.props;
    const { showTouchpointQuestionEditModalCreateIntake, showTouchpointQuestionEditModalEditIntake } = modifyIntakeActions || {};
    const { params } = match || {};
    const { id: intakeFormId } = params || {};

    const questionModalText = "Enter custom label and tooltip for touchpoint.";
    accessibilityNotificationsEmitter.assertive(questionModalText);

    if(formMode === intakeFormConstants.editStatus.createNew) {
      showTouchpointQuestionEditModalCreateIntake(touchpointId);
    }
    else if(formMode === intakeFormConstants.editStatus.editExisting) {
      showTouchpointQuestionEditModalEditIntake(touchpointId, intakeFormId);
    }
  }

  handleUpdateCustomLabel(label) {
    const { modifyIntakeActions } = this.props;
    const { updateCustomLabel } = modifyIntakeActions;
    updateCustomLabel(label);
  }

  handleUpdateCustomTooltip(tooltip) {
    const { modifyIntakeActions } = this.props;
    const { updateCustomTooltip } = modifyIntakeActions;
    updateCustomTooltip(tooltip);
  }

  applyQuestionOptions() {
    const { modifyIntake, modifyIntakeActions } = this.props;
    const { editQuestion } = modifyIntake;
    const { questionEditModalQuestionId: touchpointId, label, tooltip } = editQuestion || {};

    this.handleUpdateQuestion(touchpointId, intakeFormConstants.label, label);
    this.handleUpdateQuestion(touchpointId, intakeFormConstants.tooltip, tooltip);
    modifyIntakeActions.closeTouchpointQuestionEditModal();

  }

  getTouchpointQuestions() {
    const { value } = this.props;
    var questions = value && value.get(intakeFormConstants.touchpointSection);
    return !!questions ? questions.sort((a, b) =>
      a.get(intakeFormConstants.order) - b.get(intakeFormConstants.order)) : List([]);
  }

  getTouchpointList() {
    const { modifyIntake, siteId, programId } = this.props;
    const { touchpointInfo, validIntakeTouchpoints } = modifyIntake || {};

    const { data : allTouchpoints } = touchpointInfo || {};

    const validTouchpointState = validIntakeTouchpoints && validIntakeTouchpoints.getIn([siteId, programId]);
    const { data : validTouchpointIds } = validTouchpointState || {};
    var touchpointList = [{ value: '', label: "--Select--" }];

    if(!allTouchpoints || !validTouchpointIds) {
      return touchpointList;
    }
    const validTouchpoints = allTouchpoints.filter(val => validTouchpointIds.includes(val.formId));
    var touchpointOptions = (validTouchpoints === null || validTouchpoints === undefined) ?
      [] : validTouchpoints.map(result => { return { value: result.formId, label: result.formName }});
    touchpointList.push(...touchpointOptions);
    return touchpointList;
  }

  renderErrorDisplay(touchpointForm) {
    if(!touchpointForm) {
      return null;
    }

    const elements = touchpointForm && touchpointForm.elements;
    const hasUnsupportedElements = !!elements && elements.some(val => val.isUnsupported && !val.disabled && !val.isRequired);
    const errorText = [];
    elements && elements.forEach(element => {
      if(element.isUnsupported && !element.disabled && !element.isRequired) {
        var error = element.typeLabel+ ' : ' + element.label + (element.reason ? `(${element.reason})` : '');
        errorText.push(error);
      }
    });

    if(hasUnsupportedElements) {
      return (
      <InlineWarningList
        id="warning"
        show={true}
        warningMain={`TouchPoint ${touchpointForm.name} has some elements that cannot be used in an intake form.`}
        warningList={errorText}/>
      );
    }
    else {
      return null;
    }
  }

  renderQuestion(touchpointForm, question, showUpArrow, showDownArrow) {
    const { disabled } = this.props;
    const elementId = question && question.get(intakeFormConstants.elementId);
    const isIncluded = question && question.get(intakeFormConstants.included);
    const isRequired = question && question.get(intakeFormConstants.required);
    const element = touchpointForm && touchpointForm.elements &&
      touchpointForm.elements.find(val => val.id === elementId);
    if(!element) {
      return <tr key={elementId}/>
    }

    // this is a list of the touchpoint elements types that should not be editable
    const touchpointHiddenTypes = [
      'page',   //  Page Element (header)
      'heading',//  Section Header
      'help'    //  Message / Instruction Text
    ]

    const editLabel = touchpointHiddenTypes.includes(element.type) || element.type === undefined || element.type === null ? null :
      <span className="edit-label">
        <a onClick={e => this.handleEditClick(elementId)} tabIndex={0}>Edit</a>
      </span>

    return (
      <tr key={elementId}>
        <td>
          <div className={showUpArrow ? '' : 'hidden'}>
            <span
              tabIndex={0}
              role="button"
              className="glyphicon glyphicon-chevron-up"
              title='Move Up'
              aria-label='Move Up'
              onClick={e => this.handleUpdateOrder(elementId, element.label, true)}
              onKeyDown={e => this.handleKeyboardInput(e, elementId, element.label, true)}/>
          </div>
          <div className={showDownArrow ? '' : 'hidden'}>
            <span
              tabIndex={0}
              role="button"
              className="glyphicon glyphicon-chevron-down"
              title='Move Down'
              aria-label='Move Down'
              onClick={e => this.handleUpdateOrder(elementId, element.label, false)}
              onKeyDown={e => this.handleKeyboardInput(e, elementId, element.label, false)}/>
          </div>
        </td>

        <td className='table-text-content'>
          <div>
            <span className="question-label">{element.label}</span>
            {editLabel}
          </div>
        </td>

        <td className='table-text-content'>{element.typeLabel}</td>
        <td>
          <input
            id={elementId + "-isIncluded"}
            type="checkbox"
            checked={isIncluded}
            disabled={element.isRequired || disabled}
            onChange={e => this.handleUpdateIncluded(elementId, e.target.checked)}
            aria-label={"include"} />
        </td>
        <td>
          <input
            id={elementId + "-isRequired"}
            type="checkbox"
            checked={isRequired}
            disabled={!isIncluded || element.isRequired || disabled}
            onChange={e => this.handleUpdateQuestion(elementId, intakeFormConstants.required, e.target.checked)}
            aria-label={"required"} />
        </td>
      </tr>
    );
  }

  render() {
    const { selectedTouchpointId, disabled, modifyIntake, siteId, programId, intakeValidationResult, validationMessage, loadingValidation } = this.props;
    const { touchpoints, touchpointInfo, validIntakeTouchpoints, editQuestion } = modifyIntake || {};
    const { showQuestionEditModal, questionEditModalQuestionId, label: editCustomLabel, tooltip: editCustomTooltip } = editQuestion || {};

    const { isFetching : infoLoading, err : infoErr } = touchpointInfo || {};

    const validTouchpointState = validIntakeTouchpoints && validIntakeTouchpoints.getIn([siteId, programId]);
    const { isFetching : validIdsLoading, err : validIdsErr } = validTouchpointState || {};

    const touchpointState = touchpoints && touchpoints.get(selectedTouchpointId);
    const { isFetching : touchpointLoading, err : touchpointErr, data : selectedTouchpoint } = touchpointState || {};

    const touchpointList = this.getTouchpointList();

    //get the demographic name, type and other ETO information
     const element = selectedTouchpoint && selectedTouchpoint.elements &&
     selectedTouchpoint.elements.find(val => val.id === questionEditModalQuestionId);

    const values = this.getTouchpointQuestions();

    const modal =
      <EditQuestionModal
        modalId="questionModalId"
        contentId="questionModalContent"
        show={showQuestionEditModal}
        onCancel={() => this.handleEditQuestionCancel()}
        onSave={(label, tooltip) => this.applyQuestionOptions(questionEditModalQuestionId, label, tooltip)}
        onLabelChange={(label) => this.handleUpdateCustomLabel(label)}
        onTooltipChange={(tooltip) => this.handleUpdateCustomTooltip(tooltip)}
        title={element && element.label}
        subtitle={element && element.type}
        label={editCustomLabel}
        tooltip={editCustomTooltip} />

    return (
      <div id="modify-touchpoint">
        <IntakeFormValidation
          validationResult={intakeValidationResult}
          excludedSections={[
            validationConstants.aboutSection,
            validationConstants.demographicsSection,
            validationConstants.loadingSection,
          ]}
          titleMessage={validationMessage}
          hideSectionHeaders={true}
          isLoading={loadingValidation}/>
        <p>Questions from a TouchPoint can be appended to Demographics questions on intake forms.</p>
        <p>If you include a TouchPoint in this intake form, {tenantHelpers.getProductName()} will create a Participant record and record a TouchPoint response for each user completing the form.</p>
        <br />
        <form className="form-horizontal">
          <GenericError id='dropdown-err' err={infoErr || validIdsErr}/>
          <div className="dropdown-wrapper">
            <div className="dropdown-label">
              <label className="label-override">TouchPoint</label>
            </div>
            <div className="touchpoint-dropdown">
              <SearchableDropdown
                id="touchpoint-select-dropdown-id"
                name="touchpoint-select-dropdown"
                options={touchpointList}
                value={selectedTouchpointId}
                isDisabled={disabled}
                isLoading={infoLoading || validIdsLoading}
                onChange={newValue => this.handleUpdateTouchpoint(newValue.value)}
                ariaLabel="Select Touchpoint"
                autoFocus={true}
              />
            </div>
          </div>
          { !!selectedTouchpointId ? (
            <LoadingPane
              isLoading={touchpointLoading}
              err={touchpointErr}
              loadingMessage={"Loading touchpoint form..."}>
              {this.renderErrorDisplay(selectedTouchpoint)}
              <Table
                header={
                  <tr>
                    <th>Order</th>
                    <th>Element</th>
                    <th>Element Type</th>
                    <th>Include</th>
                    <th>Required</th>
                  </tr>
                }
                items={values.toArray()}
                mapItem={(val, index) => this.renderQuestion(selectedTouchpoint, val, index !== 0, index !== values.size - 1)}
                emptyMessage={"This touchpoint has no elements"}/>
            </LoadingPane>
          ) : null}

        </form>
        {modal}
      </div>
    );
  }
}

ModifyTouchpointComponent.propTypes = {
  modifyIntakeActions : PropTypes.object,
  modifyIntake : PropTypes.object,

  siteId: PropTypes.string,
  programId: PropTypes.string,
  selectedTouchpointId: PropTypes.string,

  value : PropTypes.object,
  defaultValue : PropTypes.object,

  intakeValidationResult : PropTypes.object,
  validationMessage : PropTypes.string,
  loadingValidation : PropTypes.bool,
  validationErr : PropTypes.object,

  updateValue : PropTypes.func,
  updateOrder: PropTypes.func,
  updateTouchpoint: PropTypes.func,
  disabled : PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool,
  formMode: PropTypes.oneOf(intakeFormConstants.editStatus),
};

const mapStateToProps = ({ modifyIntake }) => {
  return {
    modifyIntake,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    modifyIntakeActions: bindActionCreators(modifyIntakeActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModifyTouchpointComponent);
